export default __webpack_public_path__ + "media/images/cta_blocks/create_your_menu-1151f1cc0a3b0a0b9b907e4c1a17b0b3.jpg";